import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { BaseAuthService } from '../services/base-auth.service';
import { User } from '../models/user';

/**
 * This guard should be used in the login page to prevent accessing it when the
 * user is already logged in.
 */
@Injectable()
export class NoAuthGuard implements CanActivate {
  private readonly authService = inject(BaseAuthService<User, unknown>);
  private readonly router = inject(Router);

  async canActivate() {
    if (!(await this.authService.isAccessTokenValid())) {
      return true;
    }

    /*
     * Here we don't handle the refresh token since it's already handled by the auth.guard.
     * This guard just protect the login page from unintentional navigation.
     */

    return this.router.createUrlTree(['/']);
  }
}
